<form novalidate #propertyFeaturesSectionForm="ngForm">
    <tg-row *ngIf="draftLoaded$ | async">
        <tg-col md="8" sm="12">
            <tg-row>
                <tg-col>
                    <h2>Features</h2>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col>
                    <p>
                        Provide some further details about the features that
                        make the property stand out
                    </p>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="4">
                    <tg-select-container
                        class="hide-optional-label"
                        label="Bedrooms"
                    >
                        <select
                            tgSelect
                            name="bedrooms"
                            (change)="publish()"
                            [(ngModel)]="draftData.propertyInformation.bedrooms"
                            [validation]="
                                validation.propertyInformation.bedrooms
                                    | toValidator: metadata.bedrooms
                            "
                            [disabled]="isDisableInput"
                        >
                            <option
                                *ngFor="let opt of metadata.bedrooms"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
                <tg-col md="4">
                    <tg-select-container
                        class="hide-optional-label"
                        label="Bathrooms"
                    >
                        <select
                            tgSelect
                            name="bathrooms"
                            (change)="publish()"
                            [(ngModel)]="
                                draftData.propertyInformation.bathrooms
                            "
                            [validation]="
                                validation.propertyInformation.bathrooms
                                    | toValidator: metadata.bathrooms
                            "
                            [disabled]="isDisableInput"
                        >
                            <option
                                *ngIf="
                                    draftData.propertyInformation.bathrooms ===
                                    0
                                "
                                [ngValue]="0"
                                selected
                            ></option>
                            <option
                                *ngFor="let opt of metadata.bathrooms"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="4">
                    <tg-select-container label="Separate Toilets">
                        <select
                            tgSelect
                            name="toilets"
                            (change)="publish()"
                            [(ngModel)]="draftData.propertyInformation.toilets"
                            [validation]="
                                validation.propertyInformation.toilets
                                    | toValidator: metadata.toilets
                            "
                        >
                            <option
                                [ngValue]="null"
                                [selected]="
                                    !draftData.propertyInformation.toilets
                                "
                            ></option>
                            <option
                                *ngFor="let opt of metadata.toilets"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
                <tg-col md="4">
                    <tg-select-container label="Ensuite bathrooms">
                        <select
                            tgSelect
                            name="ensuites"
                            (change)="publish()"
                            [(ngModel)]="draftData.propertyInformation.ensuites"
                            [validation]="
                                validation.propertyInformation.ensuites
                                    | toValidator: metadata.ensuites
                            "
                            [validation]="
                                validation.propertyInformation.ensuites
                                    | toValidator: metadata.ensuites
                            "
                        >
                            <option [ngValue]="null"></option>
                            <option
                                *ngFor="let opt of metadata.ensuites"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="4">
                    <tg-select-container label="Living areas / Lounges">
                        <select
                            tgSelect
                            name="lounges"
                            (change)="publish()"
                            [(ngModel)]="draftData.propertyInformation.lounges"
                            [validation]="
                                validation.propertyInformation.lounges
                                    | toValidator: metadata.lounges
                            "
                        >
                            <option [ngValue]="null"></option>
                            <option
                                *ngFor="let opt of metadata.lounges"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
                <tg-col md="4">
                    <tg-select-container label="Studies">
                        <select
                            tgSelect
                            name="studies"
                            (change)="publish()"
                            [(ngModel)]="draftData.propertyInformation.studies"
                            [validation]="
                                validation.propertyInformation.studies
                                    | toValidator: metadata.studies
                            "
                        >
                            <option
                                [ngValue]="null"
                                [selected]="
                                    !draftData.propertyInformation.studies
                                "
                            ></option>
                            <option
                                *ngFor="let opt of metadata.studies"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
            </tg-row>
        </tg-col>
        <tg-col md="4" sm="12">
            <property-side-card [icon]="sideCardIcon" [heading]="sideCardHeading"
                [callToActionText]="sideCardCallToActionText" [callToActionLink]="sideCardCallToActionLink">
                {{ sideCardDescription }}
            </property-side-card>
        </tg-col>
    </tg-row>
</form>
